<div class="container">
  <form [formGroup]="petUpdateForm" (ngSubmit)="onSubmit()">
    <h2 class="mt-3 mb-3 text-center">
      {{ 'Update pet Info' | translate }}
    </h2>
    <div class="row mt-2 pt-2 mb-2">
      <div class="col-sm-12">
        <div class="registerforpet-form">
          <!-- <h1>Sted og dato funnet</h1> -->
          <div class="width-100 mb-5">
            <div class="form-feilds">
              <label class="required-star">{{'Pet Image' | translate }}</label>
              <div class="upload-petsphoto">
                <div class="muliple-photos">
                  <label class="camer-label" for="file">
                    <span *ngIf="!viewMode">
                      <mat-icon>camera_alt</mat-icon>
                    </span>
                    <span *ngIf="!viewMode">Change Image</span>
                  </label>
                  <div [ngClass]="{'is-invalid':submitted && petf.Image.errors}">
                    <img [src]="previewUrl" alt="" title="">
                    <input type="file" (change)="fileProgress($event)" formControlName="Image">
                  </div>
                </div>
              </div>
              <div style="font-size: 80%;color: #dc3545;" id="error-msg">{{ imageError }}</div>
              <div *ngIf="submitted && petf.Image.errors" class="invalid-feedback">
                <div *ngIf="petf.Image.errors.required">{{'Pet Image is required' | translate}}</div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-0">
            <div class="form-feilds mb-3" *ngIf="IsChipID">
              <label class="d-sm-block">{{'Chipnumber' | translate }} </label>
              <input type="text" class="form-control" formControlName="ChipID">
            </div>
          </div>

          <div class="width-100 mb-2" *ngIf="IsLost">
            <div class="form-feilds mb-3">
              <label class="required-star">{{ 'Pet Name' | translate }}</label>
              <input type="text" class="form-control" minlength="3" maxlength="60" formControlName="PetName"
                [ngClass]="{'is-invalid':submitted && petf.PetName.errors}">
              <div *ngIf="submitted && petf.PetName.errors" class="invalid-feedback">
                <div *ngIf="petf.PetName.errors.required">{{'Pet name is required'| translate}}</div>
                <div *ngIf="petf.PetName.errors.minlength">{{'Pet name is of more then 3 char'| translate}}</div>
                <div *ngIf="petf.PetName.errors.maxlength">{{'Pet name is not more then 60 char' | translate}}</div>
                <div *ngIf="petf.PetName.errors.whitespace && !petf.PetName.errors.required">{{'Space is not
                  allowed'|translate}}</div>
              </div>
            </div>
          </div>


          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class=" required-star">{{ 'Choose Species' | translate }}</label>
              <select class="form-control" formControlName="MasterSpeciesID" (change)="getBreeds()"
                style="width: 100%;">
                <option value="" selected disabled>Select</option>
                <option *ngFor="let species of MasterSpecies" [value]="species.Value">{{species.Text}}</option>
              </select>
              <div *ngIf="submitted && petf.MasterSpeciesID.errors" class="invalid-feedback">
                <div *ngIf="petf.MasterSpeciesID.errors.required">{{'Species is required' | translate}}</div>
              </div>
            </div>
          </div>


          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="">{{ 'Breed' | translate }}</label>
              <select class="form-control" formControlName="MasterBreedID" style="width: 100%;"
                [ngClass]="{'is-invalid':submitted && petf.MasterBreedID.errors}">
                <option value="">{{'Do not Know' |translate }}</option>
                <option *ngFor="let brd of MasterBreeds" [value]="brd.Value">{{brd.Text}}</option>
              </select>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label>{{ 'Gender' | translate }}</label>
              <div class="d-none d-sm-block">
                <div class="pets-gender mb-4">
                  <div class="custom-radio">
                    <label for="male" style="margin-left:40px;">{{'Male' | translate }}</label>
                    <input type="radio" id="male" name="" value='1' formControlName="Gender" class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="female" style="margin-left:40px;">{{'Female' | translate }}</label>
                    <input type="radio" id="female" name="" value='2' formControlName="Gender"
                      class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="DoNotKnow" style="margin-left:40px;">{{ 'Do not Know' | translate }}</label>
                    <input type="radio" id="DoNotKnow" name="" value='0' formControlName="Gender"
                      class="form-check-input">
                  </div>
                </div>
              </div>

              <div class="pets-gender d-block d-sm-none">
                <select class="form-control" formControlName="Gender" style="width: 100%;">
                  <option value="1">{{'Male' |translate }}</option>
                  <option value="2">{{'Female' |translate }}</option>
                  <option value="0" selected>{{'Do not Know' |translate }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-2">
              <label>{{ 'HairType' | translate }}</label>
              <div class="d-none d-sm-block">
                <div class="pets-gender mb-4">
                  <div class="custom-radio">
                    <label for="longhair" style="margin-left:40px;">{{ 'LongHair' | translate }}</label>
                    <input type="radio" id="longhair" name="" value="1" formControlName="HairType"
                      class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="sorthair" style="margin-left:40px;">{{ 'ShortHair' | translate }}</label>
                    <input type="radio" id="sorthair" name="" value="2" formControlName="HairType"
                      class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="hairDoNotKnow" style="margin-left:40px;">{{ 'Do not Know' | translate }}</label>
                    <input type="radio" id="hairDoNotKnow" name="" value="0" formControlName="HairType"
                      class="form-check-input">
                  </div>
                </div>
              </div>
              
              <div class="pets-gender d-block d-sm-none">
                <select class="form-control" formControlName="HairType" style="width: 100%;">
                  <option value="1">{{'LongHair' |translate }}</option>
                  <option value="2">{{'ShortHair' |translate }}</option>
                  <option value="0" selected>{{'Do not Know' |translate }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Color' | translate }}</label>
              <input type="text" class="form-control" formControlName="Color" />
            </div>
          </div>
          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Owner Phone No.' | translate }}</label>
              <input type="number" onKeyPress="if(this.value.length==10) return false;" maxlength="10" max="10" class="form-control" value="" formControlName="OwnerContactNumber">
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Owner Email' | translate }}</label>
              <input type="email" onKeyPress="if(this.value.length==25) return false;" maxlength="25" class="form-control" value="" formControlName="OwnerEmail">
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Contact' | translate }}</label>
              <input type="number" onKeyPress="if(this.value.length==10) return false;" maxlength="10" max="10" class="form-control" value="" formControlName="userContactNumber">
            </div>
          </div>

          <div class="width-100 mb-2" *ngIf="IsLost">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Age' | translate }} <span>({{ 'Year' |
                  translate}})</span></label>
              <input type="number" name="petage" min="1" class="form-control" formControlName="Age" />
            </div>
            <div style="font-size: 80%;color: #dc3545;" id="Ageerror-msg">{{ ageError | translate }}</div>
          </div>


          <div class="width-100 mb-4">
            <div class="form-feilds required-star">
              <label *ngIf="IsLost">{{ 'Date when Lost' | translate }}</label>
              <label *ngIf="!IsLost">{{ 'Date when Found' | translate }}</label>
            </div>
            <div class="date-details form-feilds d-sm-flex">
              <div class="custom-city mr-2">
                <input class="form-control" formControlName="LostFoundDate" type="datetime-local" />
              </div>
              <div *ngIf="submitted && petf.LostFoundDate.errors" class="invalid-feedback">
                <div *ngIf="petf.LostFoundDate.errors.required && IsLost">{{'Date Of Lost is required'| translate}}
                </div>
                <div *ngIf="petf.LostFoundDate.errors.required && !IsLost">{{'Date Of Lost is required'| translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-6">
            <div class="form-feilds mb-3">
              <label class="required-star"> {{'Area where lost' | translate }}</label>
              <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" formControlName="Area"
                placeholder="{{ 'Search Nearest Location' | translate }}" autocorrect="off" autocapitalize="off" spellcheck="off"
                type="text" #search [ngClass]="{'is-invalid':submitted && petf.Area.errors}">
              <span class="map-info">{{ 'MapInfo' | translate }}</span>
              <div *ngIf="submitted && petf.Area.errors" class="invalid-feedback">
                <div *ngIf="petf.Area.errors.required">{{'Area is required'| translate}}</div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">           
            <div class="d-flex width-100 form-feilds">
              <div class="custom-city mr-2">
                <input type="text" class="form-control" value="" formControlName="ZipCode" placeholder="ZipCode"
                  [ngClass]="{'is-invalid':submitted && petf.ZipCode.errors}">
                <div *ngIf="submitted && petf.ZipCode.errors" class="invalid-feedback">
                  <div *ngIf="petf.ZipCode.errors.required">{{'Zipcode is required'| translate}}</div>
                  <div *ngIf="petf.ZipCode.errors.whitespace">{{'Space is not allowed'| translate}}</div>
                </div>
              </div>

              <div class="custom-zipcode ml-2">
                <input type="text" class="form-control" value="" formControlName="City" placeholder="City"
                  [ngClass]="{'is-invalid':submitted && petf.City.errors}">
                <div *ngIf="submitted && petf.City.errors" class="invalid-feedback">
                  <div *ngIf="petf.City.errors.required">{{'City is required'| translate}}</div>
                  <div *ngIf="petf.City.errors.whitespace && !petf.City.errors.required">{{'Space is not allowed'|
                    translate}}</div>
                </div>
              </div>
            </div>

            <div style="margin-top:10px; display: none;">
              <div class="custom-city mr-2">
                <input type="text" class="form-control" value="" formControlName="District" placeholder="District"
                  [ngClass]="{'is-invalid':submitted && petf.District.errors}">
                <div *ngIf="submitted && petf.District.errors" class="invalid-feedback">
                  <div *ngIf="petf.District.errors.whitespace">{{'Space is not allowed'| translate}}</div>
                </div>
              </div>
              <div class="custom-zipcode ml-2">
                <input type="text" class="form-control" value="" formControlName="State" placeholder="State"
                  [ngClass]="{'is-invalid':submitted && petf.State.errors}">
                <div *ngIf="submitted && petf.State.errors" class="invalid-feedback">
                  <div *ngIf="petf.State.errors.required">{{'State is required'| translate}}</div>
                  <div *ngIf="petf.State.errors.whitespace && !petf.State.errors.required">{{'Space is not allowed'|
                    translate}}</div>
                </div>
              </div>
            </div>
          </div>

          <div style="display: none;">
            <div class="form-feilds mb-3">
              <select class="form-control" formControlName="Country" style="width: 100%;">
                <option value="" selected disabled>{{'Select' |translate }}</option>
                <option *ngFor="let cntry of country" [value]="cntry.Text">{{cntry.Text}}</option>
              </select>
              <div *ngIf="submitted && petf.Country.errors" class="invalid-feedback">
                <div *ngIf="petf.Country.errors.required">{{'Country is required'| translate}}</div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-sm-block">{{ 'Additional Info' | translate }}</label>              
              <textarea class="form-control cus-texthgi" formControlName="AdditionalInfo"
                id="exampleFormControlTextarea1" rows="140" cols="50" placeholder=""></textarea>
            </div>
          </div>

          <div class="width-100">
            <div class="toggle-swicther">
              <div [ngClass]="togglePhoneNumber ? 'toggle-btn active' : 'toggle-btn'" (click)="toggleContractInfo()">
                <input type="checkbox" style="display: none;" value="1" class="form-check-input" id="exampleCheck1"
                  formControlName="GDPRUserStatus">
                <div class="inner-circle"></div>
              </div>
              <label class="ml-2">{{ 'Show my email and mobile number' | translate }}</label>
            </div>
          </div>

          <div class="btns-box row">
            <div class="mt-2 mb-4 col-md-12">
              <button type="submit" class="btn btn-primary mr-3" *ngIf="!viewMode">{{ 'Save' | translate }}</button>
              <!-- <button type="button" class="btn btn-secondary" (click)=Redirectdashborad();>{{ 'Cancel' | translate }}</button> -->
              <a class="btn btn-secondary" href="dashboard">{{ 'Cancel' | translate }}</a>
              <button class="btn btn-lg btn-outline-primary" id="contentNew" (click)="open(content)"
                style="display: none;">Modal</button>
            </div>
          </div>
        </div>
      </div>
    </div>
<label formControlName="FacebookUserId" style="display: none;"></label>
<label formControlName="ShortLivedToken" style="display: none;"></label>
  </form>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'Crop Image'| translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="text-center col-md-12">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
        [resizeToWidth]="256" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="text-center col-md-4">
      <h5>{{'Preview'|translate}}</h5>
      <img [src]="croppedImage" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">{{'Save'|
      translate}}</button>
  </div>
</ng-template>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{'Please Wait.'| translate}} </p>
</ngx-spinner>